import React from 'react';

import { IOption } from './constants';

export interface ISelectFieldOption extends IOption {
  isSelected?: boolean;
}

interface IProps {
  options: ISelectFieldOption[];
  addEmptyOption?: boolean;
  keepOriginalOrder?: boolean;
}

function FormSelectFieldOptions({ options, addEmptyOption = true, keepOriginalOrder = false }: IProps) {
  const orderedOptions = keepOriginalOrder
    ? options
    : options.sort((option1, option2) => {
        return option1.label.localeCompare(option2.label);
      });

  const optionElements = orderedOptions.map((option, i) => (
    <option key={option.key || i} value={option.value} selected={option.isSelected}>
      {option.label}
    </option>
  ));

  if (addEmptyOption) optionElements.unshift(<option key="__" value="" />);

  return <React.Fragment>{optionElements}</React.Fragment>;
}

export default FormSelectFieldOptions;
